module.exports = __webpack_public_path__ + "img/Weapon_102.02bb3b42.png";